import { IDictionaryTypes } from '~/services/api/dictionaries/types';

const dispositionDictionary = {
  type: IDictionaryTypes.Dispositions,
  name: 'Disposition',
};

export default dispositionDictionary;
